import { Calendar } from "@/components/ui/calendar";
import { Input } from "@/components/ui/input";

interface DateTimeSelectProps {
  date: Date | undefined;
  time: string;
  onDateChange: (date: Date | undefined) => void;
  onTimeChange: (time: string) => void;
}

export const DateTimeSelect = ({ date, time, onDateChange, onTimeChange }: DateTimeSelectProps) => (
  <div className="grid md:grid-cols-2 gap-6">
    <div className="space-y-2">
      <label className="text-sm font-medium">Data Inicial</label>
      <div className="bg-white rounded-lg border shadow-sm">
        <Calendar
          mode="single"
          selected={date}
          onSelect={onDateChange}
          className="rounded-md"
        />
      </div>
    </div>

    <div className="space-y-2">
      <label className="text-sm font-medium">Horário</label>
      <Input
        type="time"
        value={time}
        onChange={(e) => onTimeChange(e.target.value)}
        className="h-10"
      />
    </div>
  </div>
);